
export const getNumberOfUsedFilters = (filters) => {
    let numberOfUsedFilters = null;

    if (filters) {
        numberOfUsedFilters = Object.entries(filters)
            .filter(([key, value]) => key !== "startPage" && key !== "limitPage")
            .map(([, value]) => value)
            .filter(value => value !== "" && value !== null && value !== undefined);
        return numberOfUsedFilters.length === 0 ? null : numberOfUsedFilters.length;
    }

    return numberOfUsedFilters;
}
